import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import styles from './ReportForm.module.scss';
import { AppContext } from '../../context/AppContext';
import GenericButton from '../../components/generic-button/GenericButton';
import ReportButton from '../../components/report-button/ReportButton';
import { ProfileIcon } from '../../components/icons/Icons';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { DirectoryListType } from '../directory-list/DirectoryList';

const validationSchema = Yup.object().shape({
  correctedName: Yup.string(),
  correctedAddress: Yup.string(),
  correctedPhoneNumber: Yup.string(),
  correctedFax: Yup.string(),
  //acceptingNewPatients: Yup.string(),
  comments: Yup.string(),
  reporterName: Yup.string().required('Required'),
  reporterPhoneNumber: Yup.string().required('Required'),
  reporterEmail: Yup.string().email('Invalid email address').required('Required')
});

const ReportForm = (props: any) => {
  const appContext = useContext(AppContext);
  const primaryResult = props.primaryResult;
  const [submitted, setSubmitted] = useState(false);
  const [submissionError, setSubmissionError] = useState({
    errorStatus: false,
    errorMessage: ''
  });

  const currentProfile = {
    currentName: primaryResult?.name,
    currentAddress: `${primaryResult?.addressLine1}, ${primaryResult?.city}, ${primaryResult?.state} ${primaryResult?.zipCode}`,
    currentPhoneNumber: primaryResult?.phone,
    currentFax: primaryResult?.fax
  };
  if (primaryResult?.addressLine2) {
    currentProfile.currentAddress = `${primaryResult?.addressLine1} ${primaryResult?.addressLine2} ${primaryResult?.city}, ${primaryResult?.state} ${primaryResult?.zipCode}`;
  }
  const formik = useFormik({
    initialValues: {
      correctedName: '',
      correctedAddress: '',
      correctedPhoneNumber: '',
      correctedFax: '',
      //acceptingNewPatients: '',
      comments: '',
      reporterName: '',
      reporterPhoneNumber: '',
      reporterEmail: ''
    },
    validationSchema,
    onSubmit: async (values) => {
      /* console.log(JSON.stringify({...values,
        planTitle: window.location.host.split('.')[0],
        planBase: window.location.host === 'localhost:3000' ? 'alignseniorcare.com' : window.location.host,
        ...currentProfile}, null, 2)); */
      let directoryType = '';
      if (appContext.directoryListType === DirectoryListType.pharmacy) {
        directoryType = 'Pharmacy ';
      }
      await axios
        .post(`/SendCorrectedEmail`, {
          planTitle: window.location.host,
          planBase: 'simpra.com',
          ...currentProfile,
          ...values,
          directoryType
        })
        .then((res) => {
          setSubmitted(true);
          //formik.resetForm();
        })
        .catch((err) => {
          console.error(err);
          setSubmissionError({
            errorStatus: true,
            errorMessage: `An error submitting the information occured.`
          });
        });
    }
  });

  return (
    <div className={styles.formContainer}>
      <form className={styles.formSection}>
        <table className={styles.reportTable}>
          <colgroup>
            <col span={1} style={{ width: '20%' }} />
            <col span={1} style={{ width: '30%' }} />
            <col span={1} style={{ width: '20%' }} />
            <col span={1} style={{ width: '30%' }} />
          </colgroup>
          <thead>
            <tr>
              <th className="table-header" colSpan={2}>
                CURRENT PROVIDER INFORMATION
              </th>
              <th className="table-header" colSpan={2}>
                UPDATED PROVIDER INFORMATION
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{appContext.directoryListType === DirectoryListType.pharmacy ? 'Pharmacy Name' : 'Name'}</td>
              <td>{primaryResult?.name}</td>
              <td>
                <label htmlFor="correctedName">Corrected {appContext.directoryListType === DirectoryListType.pharmacy ? 'Pharmacy Name' : 'Name'}</label>
              </td>
              <td>
                <input id="correctedName" name="correctedName" type="text" onChange={formik.handleChange} value={formik.values.correctedName} />
                {formik.touched.correctedName && formik.errors.correctedName ? <div>{formik.errors.correctedName}</div> : null}
              </td>
            </tr>
            <tr>
              <td>Address</td>
              <td>
                {primaryResult?.addressLine1},
                <br />
                {primaryResult?.addressLine2 ? (
                  <span>
                    {primaryResult?.addressLine2 + ','}
                    <br />
                  </span>
                ) : null}
                {primaryResult?.city}, {primaryResult?.state} {primaryResult?.zipCode}
              </td>
              <td>
                <label htmlFor="correctedAddress">Corrected Address</label>
              </td>
              <td>
                <textarea id="correctedAddress" name="correctedAddress" cols={20} rows={2} onChange={formik.handleChange} value={formik.values.correctedAddress}></textarea>
                {formik.touched.correctedAddress && formik.errors.correctedAddress ? <div>{formik.errors.correctedAddress}</div> : null}
              </td>
            </tr>
            <tr>
              <td>Phone Number</td>
              <td>{primaryResult?.phone}</td>
              <td>
                <label htmlFor="correctedPhoneNumber">Corrected Phone Number</label>
              </td>
              <td>
                <input id="correctedPhoneNumber" name="correctedPhoneNumber" type="text" onChange={formik.handleChange} value={formik.values.correctedPhoneNumber}></input>
                {formik.touched.correctedPhoneNumber && formik.errors.correctedPhoneNumber ? <div>{formik.errors.correctedPhoneNumber}</div> : null}
              </td>
            </tr>
            <tr>
              <td>Fax</td>
              <td>{primaryResult?.fax}</td>
              <td>
                <label htmlFor="correctedFax">Corrected Fax</label>
              </td>
              <td>
                <input id="correctedFax" name="correctedFax" type="text" onChange={formik.handleChange} value={formik.values.correctedFax}></input>
                {formik.touched.correctedFax && formik.errors.correctedFax ? <div>{formik.errors.correctedFax}</div> : null}
              </td>
            </tr>
            {/* <tr>
              <td>Accepting New Patients</td>
              <td>{primaryResult?.acceptingNewPatients}</td>
              <td>
                <label htmlFor="acceptingNewPatients">Corrected Accepting New Patients</label>
              </td>
              <td>
                <select id="acceptingNewPatients" name="acceptingNewPatients" onChange={formik.handleChange} value={formik.values.acceptingNewPatients}>
                  <option id="Default">-</option>
                  <option id="Yes" value="Yes">
                    Yes
                  </option>
                  <option id="No" value="No">
                    No
                  </option>
                </select>
                {formik.touched.acceptingNewPatients && formik.errors.acceptingNewPatients ? <div>{formik.errors.acceptingNewPatients}</div> : null}
              </td>
            </tr> */}
            <tr>
              <td>
                <label htmlFor="comments">Comments</label>
              </td>
              <td colSpan={3}>
                <textarea id="comments" name="comments" cols={50} rows={4} onChange={formik.handleChange} value={formik.values.comments}></textarea>
                {formik.touched.comments && formik.errors.comments ? <div>{formik.errors.comments}</div> : null}
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="reporterName">Your Name</label>
              </td>
              <td colSpan={3}>
                <input id="reporterName" name="reporterName" type="text" onChange={formik.handleChange} value={formik.values.reporterName}></input>
                {formik.touched.reporterName && formik.errors.reporterName ? <div>{formik.errors.reporterName}</div> : null}
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="reporterPhoneNumber">Your Phone Number</label>
              </td>
              <td colSpan={3}>
                <input id="reporterPhoneNumber" name="reporterPhoneNumber" type="text" onChange={formik.handleChange} value={formik.values.reporterPhoneNumber}></input>
                {formik.touched.reporterPhoneNumber && formik.errors.reporterPhoneNumber ? <div>{formik.errors.reporterPhoneNumber}</div> : null}
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="reporterEmail">Your Email Address</label>
              </td>
              <td colSpan={3}>
                <input id="reporterEmail" name="reporterEmail" type="email" onChange={formik.handleChange} value={formik.values.reporterEmail}></input>
                {formik.touched.reporterEmail && formik.errors.reporterEmail ? <div>{formik.errors.reporterEmail}</div> : null}
              </td>
            </tr>
          </tbody>
        </table>
        {submitted ? <div className={styles.onSubmit}>Submission Successful</div> : null}
        {submissionError.errorStatus ? <div className={styles.onSubmit}>{submissionError.errorMessage}</div> : null}
        <div className="flex">
          <ReportButton
            buttonText={'Clear'}
            handleClick={(e) => {
              e.preventDefault();
              formik.resetForm();
              setSubmitted(false);
              setSubmissionError({
                errorStatus: false,
                errorMessage: ''
              });
            }}
          />
          <ReportButton
            buttonText={'Submit'}
            handleClick={(e) => {
              e.preventDefault();
              formik.handleSubmit();
              //formik.resetForm();
            }}
          />
          <ReportButton
            buttonText={'Cancel'}
            handleClick={(e) => {
              e.preventDefault();
              formik.resetForm();
              props.setShowReportForm(false);
              setSubmitted(false);
              setSubmissionError({
                errorStatus: false,
                errorMessage: ''
              });
            }}
          />
        </div>
      </form>
    </div>
  );
};

export default ReportForm;
